import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CtaButtonProps {
  label: string;
  subLabel?: string;
  size?: 'default' | 'large';
  tone?: 'dark' | 'gold';
  /** 'checkout' opens the store checkout, 'offer' scrolls to the offer section. */
  target?: 'checkout' | 'offer';
}
export function CtaButton({
  label,
  subLabel,
  size = 'default',
  tone = 'dark',
  target = 'checkout'
}: CtaButtonProps) {
  const isCheckout = target === 'checkout';
  return <div className="w-full" data-id="element-74" data-mp="lkfr15ncqkaf">
      <a href={isCheckout ? CHECKOUT_URL : '#offer'} {...isCheckout ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} className={`group flex w-full items-center justify-center gap-3 rounded-full text-center font-sans font-bold uppercase tracking-wide shadow-lift transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${tone === 'gold' ? 'bg-gold text-espresso outline-cream hover:bg-goldlight' : 'bg-espresso text-cream outline-gold hover:bg-cocoa'} ${size === 'large' ? 'px-8 py-5 text-base sm:text-lg' : 'px-7 py-4 text-sm sm:text-base'}`} data-id="element-75" data-mp="ll7bplfeuxlx">
        <span className="text-balance" data-id="element-76" data-mp="3juksb1chvu2w">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-77" data-mp="3ov8py5v8b963" />
      </a>
      {subLabel ? <p className="mt-3 text-center text-xs font-medium uppercase tracking-[0.14em] text-muted" data-id="element-78" data-mp="1k90owaf3ks0">
          {subLabel}
        </p> : null}
    </div>;
}